import { render, staticRenderFns } from "./ButtonsWrapper.vue?vue&type=template&id=42f1b5bd&scoped=true&"
import script from "./ButtonsWrapper.vue?vue&type=script&lang=js&"
export * from "./ButtonsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsWrapper.vue?vue&type=style&index=0&id=42f1b5bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f1b5bd",
  null
  
)

export default component.exports